
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { PositionItemProps } from ".";
import { loading, endLoading } from "store/position";

interface ApiPositionRemoveInputProps {
    ids: number[]
}

type ApiPositionRemoveOutputProps = OutputBaseProps<{ item: PositionItemProps; }>

export const apiPositionRemove = async (data: ApiPositionRemoveInputProps) => {
    store.dispatch(loading());
    const res = (await axios.delete<ApiPositionRemoveOutputProps>("/api/position/remove", { data }))
        .data;
    store.dispatch(endLoading());
    return res;
};